import moment from 'moment';

export const getTimeAgo = (date, t) => {
    const now = moment();
    const givenDate = moment(date);

    // Calculate the difference between now and the given date
    const diffInSeconds = now.diff(givenDate, 'seconds');
    const diffInMinutes = now.diff(givenDate, 'minutes');
    const diffInHours = now.diff(givenDate, 'hours');
    const diffInDays = now.diff(givenDate, 'days');
    const diffInMonths = now.diff(givenDate, 'months');
    const diffInYears = now.diff(givenDate, 'years');

    if (diffInSeconds < 60) {
        return t('a few seconds ago');
    } else if (diffInMinutes < 60) {
        return diffInMinutes === 1 ? t('a minute ago') : `${t("minutes ago",{ number: diffInMinutes})}`;
    } else if (diffInHours < 24) {
        return diffInHours === 1 ? t('an hour ago') : `${t("hours ago",{ number: diffInHours})}`;
    } else if (diffInDays < 30) {
        return diffInDays === 1 ? t('a day ago') : `${t("days ago",{ number: diffInDays})}`;
    } else if (diffInMonths < 12) {
        return diffInMonths === 1 ? t('a month ago') : `${t("months ago",{ number: diffInMonths})}`;
    } else {
        return diffInYears === 1 ? t('a year ago') : `${t("years ago",{ number: diffInYears})}`;
    }
};
